<template>
  <div class="election-result-list h-100">
    <!-- Section Title -->
    <div class="section-title-wrapper mb-4">
      <div class="section-title">
        <h2 class="text-h5 font-weight-medium">{{ title }}</h2>
        <div class="section-bar"></div>
      </div>
    </div>

    <!-- Loading Animation -->
    <v-overlay v-if="LoadingFlag" absolute class="loading-overlay">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>

    <!-- No Results Message -->
    <div v-else-if="!Records || !Records.length" class="no-results">
      <v-icon size="64" color="grey lighten-1">mdi-poll</v-icon>
      <p class="mt-4">No election results available</p>
    </div>

    <!-- Results Grid -->
    <v-row v-else class="mt-4" align="stretch">
      <v-col
        v-for="(round, index) in Records"
        :key="index"
        cols="12"
        class="d-flex"
      >
        <v-card
          outlined
          class="pa-4 round-card"
          elevation="6"
          style="width: 100%"
        >
          <!-- Round Title -->
          <div class="d-flex align-center justify-space-between mb-4">
            <h4 class="font-weight-bold">{{ round.RoundName }}</h4>
            <div class="d-flex align-center">
              <v-chip color="indigo" dark small class="mr-2">
                Round {{ round.RoundId }}
              </v-chip>
            </div>
          </div>

          <!-- Table of Members -->
          <v-data-table
            :headers="[
              { text: 'Candidate', align: 'start', value: 'MemberName' },
              {
                text: 'Photo',
                align: 'center',
                value: 'MemberImage',
                sortable: false,
              },
              { text: 'Votes', align: 'center', value: 'VoteCount' },
              { text: 'Is Eliminated', align: 'center', value: 'IsEliminated' },
            ]"
            :items="round.VoteData"
            :items-per-page="10"
            class="elevation-0"
          >
            <!-- Member Name -->
            <template #[`item.MemberName`]="{ item }">
              <span class="font-weight-medium">{{ item.MemberName }}</span>
            </template>

            <!-- Member Photo -->
            <template #[`item.MemberImage`]="{ item }">
              <div class="d-flex justify-center">
                <v-avatar size="50" class="elevation-2">
                  <v-img
                    :src="item.MemberImage"
                    :alt="item.MemberName"
                    @error="handleImageError"
                  >
                    <template v-slot:placeholder>
                      <v-avatar color="primary" size="50">
                        <span class="white--text">{{
                          getInitials(item.MemberName)
                        }}</span>
                      </v-avatar>
                    </template>
                  </v-img>
                </v-avatar>
              </div>
            </template>

            <!-- Vote Count -->
            <template #[`item.VoteCount`]="{ item }">
              <v-chip
                :color="item.IsEliminated ? 'grey' : 'teal'"
                text-color="white"
                class="font-weight-bold px-4"
              >
                {{ item.VoteCount }}
              </v-chip>
            </template>

            <!-- Status -->
            <template #[`item.IsEliminated`]="{ item }">
              <v-chip
                :color="item.IsEliminated ? 'error' : 'success'"
                text-color="white"
                small
              >
                {{ item.IsEliminated}}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import companyConfig from "@/company_config.json";

export default {
  name: "ElectionResultList",
  props: {
    conference: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    designation: {
      type: Number,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    zone: {
      type: [Number, String],
      required: false,
      default: "",
    },
  },
  data() {
    return {
      Records: [],
      LoadingFlag: false,
      defaultAvatarUrl: "/media/users/default.jpg",
    };
  },
  methods: {
    getInitials(name) {
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .substr(0, 2);
    },
    handleImageError(error) {
      if (error && error.target) {
        error.target.src = this.defaultAvatarUrl;
      }
    },
    getElectionResultRecords() {
      console.log("getTableRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nomination-vote/round-results";
      var upload = {
        UserInterface: 1,
        NominationDesignation: this.designation,
        Conference: this.conference,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.Records = [];
      this.ResultFlag = false;
      this.LoadingFlag = true;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
    
          var options = records.TableOptions;
          thisIns.tableOptions1 = options;

          if (flag == 1) {
            thisIns.Records = records;
            
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;
        });
    },

  },
  created() {
    this.getElectionResultRecords();
  },
  watch: {
    conference() {
      this.getElectionResultRecords();
    },
    designation() {
      this.getElectionResultRecords();
    },
    zone() {
      this.getElectionResultRecords();
    },
  },
};
</script>

<style lang="scss" scoped>
.election-result-list {
  position: relative;
  min-height: 200px;
  height: 100%;

  .section-title-wrapper {
    padding: 0;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding-bottom: 1rem;
  }

  .section-title {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    animation: slideInFromLeft 0.6s ease-out;

    h2 {
      color: #2c3e50;
      margin-bottom: 0.5rem;
      letter-spacing: -0.5px;
      font-weight: 600;
    }

    .section-bar {
      height: 3px;
      width: 40px;
      background: linear-gradient(to right, #2c63ac, #3498db);
      border-radius: 1.5px;
      animation: expandWidth 0.8s ease-out;
    }
  }

  .no-results {
    text-align: center;
    padding: 3rem;
    color: #95a5a6;
    animation: fadeIn 0.5s ease-out;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .round-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 100%;
    border-left: 3px solid #3f51b5;
    border-radius: 12px;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 10px 22px rgba(0, 0, 0, 0.1) !important;
    }

    table {
      th {
        font-weight: 600;
        color: #2c3e50;
        padding: 12px 15px;
        background: rgba(44, 99, 172, 0.03);
        font-size: 0.9rem;
        border-bottom: 1px solid rgba(44, 99, 172, 0.1);
      }
      td {
        padding: 12px 15px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(44, 99, 172, 0.05);
        font-size: 0.9rem;
      }
    }
  }
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes expandWidth {
  from {
    width: 0;
  }
  to {
    width: 40px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>